module.exports = "<app-datagrid-search [requestParams]=\"requestParams\" (onDoFilter)=\"doFilter($event)\" [searchEnabled]=\"searchEnabled\"></app-datagrid-search>\n<app-datagrid-list [viewMode]=\"viewMode\" [requestParams]=\"requestParams\" [searchInitialized]=\"searchInitialized\"></app-datagrid-list>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid.component.html
// module id = ../../../../../src/app/components/datagrid/datagrid.component.html
// module chunks = main